import React from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import {
  getFormQuestionAttributeUnitOfMeasure,
  hasQuestionBeenAnsweredByIndex,
  setQuestionAttributeUnitOfMeasure,
} from "reduxSlices/formBuilderSlice"
import {
  DAYS, MONTHS, WEEKS, YEARS,
} from "utils/dateDifferenceHelpers"
import { Select } from "shared/selects"
import ValidUnitOfMeasureValidation from "./UnitOfMeasureValidations"

const ANSWERED_NOTE = "Cannot be changed once the question has been answered."

const options = [
  { label: "Days", value: DAYS },
  { label: "Weeks", value: WEEKS },
  { label: "Months", value: MONTHS },
  { label: "Years", value: YEARS },
]

const unitOfMeasureLabel = (unitOfMeasure) => (
  options.find((option) => option.value === unitOfMeasure)?.label
)

const UnitOfMeasure = ({ sectionIndex, questionIndex }) => {
  const dispatch = useDispatch()

  const questionUnitOfMeasure = useSelector(getFormQuestionAttributeUnitOfMeasure({ sectionIndex, questionIndex }))
  const questionHasBeenAnswered = useSelector(hasQuestionBeenAnsweredByIndex({ sectionIndex, questionIndex }))

  const updateUnitOfMeasure = (newUnitOfMeasure) => dispatch(setQuestionAttributeUnitOfMeasure({
    sectionIndex, questionIndex, newUnitOfMeasure,
  }))

  return (
    <>
      <div className="mb-1 font-medium">
        Unit of Measure
      </div>
      {
        questionHasBeenAnswered
          ? (
            <>
              <div>{unitOfMeasureLabel(questionUnitOfMeasure)}</div>
              <p className="text-xs text-dark">{ANSWERED_NOTE}</p>
            </>
          )
          : (
            <Select
              backspaceDelete={false}
              className="text-sm"
              isFullWidth
              label="select unit of measure"
              onChange={updateUnitOfMeasure}
              options={options}
              placeholder="Unit of measure"
              style={{ height: "32px" }}
              value={questionUnitOfMeasure}
            />
          )
      }
      <ValidUnitOfMeasureValidation
        questionIndex={questionIndex}
        sectionIndex={sectionIndex}
      />
    </>
  )
}

UnitOfMeasure.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default UnitOfMeasure
